import React from 'react';
import { useTranslation } from 'react-i18next';
import { YStack, Text, Button } from 'tamagui';
import { tokens } from 'tamagui-config';

import { PinIndicator } from './PinIndicator';

interface PinPreviewProps {
  currentCount: number;
  totalCount: number;
  pinError: string | null;
  onCancel: () => void;
}

export const PinPreview: React.FC<PinPreviewProps> = ({
  currentCount,
  totalCount,
  pinError,
  onCancel,
}) => {
  const { t } = useTranslation();

  return (
    <YStack width="100%" height="100%" alignItems="center" gap="$12">
      <Text fontFamily="$body" fontSize="$9" fontWeight="$4" color={tokens.color.textLight}>
        {t('lock.enterPin')}
      </Text>
      <PinIndicator currentCount={currentCount} totalCount={totalCount} pinError={pinError} />
      <Button
        width={134}
        height={72}
        backgroundColor={tokens.color.gray3}
        borderRadius={999}
        justifyContent="center"
        alignItems="center"
        onPress={onCancel}
        cursor="pointer"
        pressStyle={{ transform: [{ scale: 0.95 }] }}>
        <Text fontFamily="$body" fontSize="$5" fontWeight="$4" color={tokens.color.textLight}>
          {t('common.cancel')}
        </Text>
      </Button>
    </YStack>
  );
};
